<template>
  <jade-box
    class="flex-1"
    :title="$t('failed.title')"
    hasPadding
  >
    <template>
      <div class="flex flex-col gap-2">
        <jade-text variant="heading-small">R$ {{ data.value }}</jade-text>
        <div>
          <jade-text>{{ computedText.label }}</jade-text>
          <jade-text>{{ computedText.percentage }}</jade-text>
        </div>
      </div>
    </template>
  </jade-box>
</template>

<script>
import { JadeBox, JadeText } from '@jade'
import TransactionStatusManager from './transaction-status.manager'

export default {
  name: 'TransactionStatusFailed',

  components: {
    JadeBox,
    JadeText
  },

  props: {
    data: Object
  },

  computed: {
    computedText () {
      const label = this.$tc('failed.sales', this.data.quantity)
      return TransactionStatusManager.getFormatedLabelAndPercentage(
        this.data,
        label
      )
    }
  }
}
</script>

<i18n>
  {
    "pt-BR": {
      "failed": {
        "title": "Não autorizado",
        "description": "Cobranças que sofreram erro em seu processamento ou não foram autorizadas.",
        "sales": "cobrança | cobrança | cobranças"
      }
    },
    "en-US": {
      "failed": {
        "title": "Not authorized",
        "description": "Charges which had an error during its processing stage or that were not authorized.",
        "sales": "charge | charge | charges"
      }
    }
  }
  </i18n>
